import styled from 'styled-components';
import {
  flexbox,
  justifyContent,
  alignItems,
  flexDirection
} from '../../styles/helpers/flexbox';

export const Wrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
   ${flexbox()};

  
    position: relative;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border-top: 1px solid ${colours.grey[400]};
    height: fit-content;
    margin-bottom: 35px;

    &::-webkit-scrollbar {
      height: 0.05px !important;
      scrollbar-width: 0.05px !important;
    }

    &::-ms-scrollbar {
      height: 0.05px !important;
      scrollbar-width: 0.05px !important;
    }
`;
});

export const EmptyWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    width: 100%;
    height: 188px;
    position: relative;
    left: 260px;
    border-top: 1px solid ${colours.grey[400]};
    border-right: 1px solid ${colours.grey[400]};
`;
});

export const RightSection = styled.div`
  ${flexbox()};
  overflow: scroll;
  width: calc(100% - 260px);
`;

export const LoaderContainer = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('baseline')};

  flex: 1;
  margin-top: 200px;
  margin-left: 25%;
  position: fixed;
`;

export const GridContainer = styled.div((props) => {
  const { colours } = props.theme;

  return `
        ${flexbox()};
        ${flexDirection('column')};

        width: 100%;
        height: fit-content;

        .cell {
            width: 82px;
            height: 40px;
            background: ${colours.grey[300]};
          }
    `;
});



// WEBPACK FOOTER //
// ./components/topics/styled.js